import {useWatch} from "react-hook-form";
import {DateUtil} from "base/format/utilities";
import {PERMIT_TYPES} from "permit/data";
import {PermitApplicationTypesFormField} from "permitapplication/presentational/form";
import {DividerWithHeading} from "base/ui/headings/components";
import {MapBaseLayout, useMapDialog} from "base/map/layout";
import {PermitApplicationTechinalDataMapProvider} from "plot/map";
import {FormDatePickerCombo, FormInputDecimal} from "base/form/components";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import FormHelperText from "@mui/material/FormHelperText";
import TransportFormDatePickerCombo from "permitapplication/presentational/form/TransportFormDatePickerCombo";

const PermitExtensionDatesContent = ({entity, isStepEditable}) => {
    const {button, getDialog} = useMapDialog();

    const types = useWatch({
        name: "types",
    });

    const displayedTypes = PERMIT_TYPES.filter(type => types?.includes(type.value));

    return (
        <>
            <Grid container mt={2}>
                <Grid item xs={6} md={9}>
                    <PermitApplicationTypesFormField
                        extension={entity}
                        disabled={!isStepEditable}
                    />
                </Grid>
                <Grid
                    item
                    container
                    xs={6}
                    md={3}
                    justifyContent="center"
                    alignItems="center"
                >
                    <span>{button}</span>
                    {getDialog(
                        <PermitApplicationTechinalDataMapProvider permit={entity}>
                            <MapBaseLayout height="100%" />
                        </PermitApplicationTechinalDataMapProvider>
                    )}
                </Grid>
            </Grid>
            <Grid container columnSpacing={6} rowSpacing={2} mt={2}>
                {displayedTypes.map(type => (
                    <Grid item xs={12} md={6} key={type.label}>
                        <DividerWithHeading label={`Nova guia de ${type.label}`} />
                        <Stack direction="row" spacing={1}>
                            {type.value === "transport" ? (
                                <TransportFormDatePickerCombo
                                    startDateLabel="Data de início"
                                    startDateName={`${type.value}_start_date`}
                                    endDateLabel="Data de caducidade"
                                    endDateName={`${type.value}_end_date`}
                                    disabled={!isStepEditable}
                                    required
                                />
                            ) : (
                                <FormDatePickerCombo
                                    startDateLabel="Data de início"
                                    startDateName={`${type.value}_start_date`}
                                    endDateLabel="Data de caducidade"
                                    endDateName={`${type.value}_end_date`}
                                    disabled={!isStepEditable}
                                    required
                                />
                            )}
                        </Stack>
                        <FormHelperText sx={{mb: 2, ml: 1, color: "secondary.main"}}>
                            Validade da autorização inicial:{" "}
                            {DateUtil.formatDateShort(
                                entity?.permit?.[`${type.value}_start_date`]
                            )}{" "}
                            -{" "}
                            {DateUtil.formatDateShort(
                                entity?.permit?.[`${type.value}_end_date`]
                            )}
                        </FormHelperText>
                        {type.value === "clearing" ? (
                            <Grid>
                                <FormInputDecimal
                                    name="clearing_area"
                                    label="Área a desbravar"
                                    endAdornment="ha"
                                    rules={{required: "Este campo é obligatório"}}
                                    disabled={!isStepEditable}
                                />
                                <FormHelperText
                                    sx={{mb: 2, ml: 1, color: "secondary.main"}}
                                >
                                    Área na autorização inicial:{" "}
                                    {entity?.permit?.clearing_area} ha
                                </FormHelperText>
                            </Grid>
                        ) : null}
                    </Grid>
                ))}
            </Grid>
        </>
    );
};

export default PermitExtensionDatesContent;
